import { Box, BoxProps } from "@chakra-ui/react";
import { AiOutlineSortAscending } from "react-icons/ai";

export const SortAscending = (props: BoxProps) => {
  return <Box as={AiOutlineSortAscending} height="20px" width="20px" {...props} />;
};
